<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="工厂代码">
					<c-input name="saas_id" maxlength="10" type="number"></c-input>
				</m-search-item>
				<m-search-item label="工厂名称">
					<c-input name="saas_name" maxlength="50"></c-input>
				</m-search-item>
				<m-search-item label="账号用户名">
					<c-input name="user_name" maxlength="20"></c-input>
				</m-search-item>
				<m-search-item label="账号姓名">
					<c-input name="user_realname" maxlength="20"></c-input>
				</m-search-item>
				<m-search-item label="手机号码">
					<c-input name="phone" maxlength="15"></c-input>
				</m-search-item>
				<m-search-item  label="风险状态">
					<c-checkbox-group name="state">
						<c-checkbox value="0">未解除</c-checkbox>
					    <c-checkbox value="1">已解除</c-checkbox>
					</c-checkbox-group>
				</m-search-item>
				<m-search-item label="风险时间" colspan="2">
					<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
				</m-search-item>
			</m-search>

			<c-table ref="list" height="grow" :paging="true">
				
				<c-table-column
					label="类型"
					name="risk_type"
					width="90"
					fixed="left"
				>
					<template #default="{data}">
						<span v-if="data.risk_type == 1">手机验证码</span>
						<span v-if="data.risk_type == 2">账号密码</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="风险状态"
					name="state"
					width="80"
				>
					<template #default="{data}">
						<span v-if="data.state == 0" style="color:red">未解除</span>
						<span v-if="data.state == 1" style="color:green">已解除</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="手机号码"
					name="phone"
					width="100"
					fixed="left"
				>
					<template #default="{data}">
						<span v-if="data.risk_type == 1 && data.state == 0" style="color:red">{{data.phone}}</span>
						<span v-else-if="data.risk_type == 1 && data.state == 1">{{data.phone}}</span>
						<span v-else-if="data.risk_type == 2 && data.phone">{{data.phone}}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="工厂代码"
					name="saas_id"
					width="80"
				>
					<template #default="{data}">
						<span v-if="data.risk_type == 1">-</span>
						<span v-if="data.risk_type == 2">{{data.saas_id}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="工厂名称"
					name="saas_name"
					width="180"
				>
					<template #default="{data}">
						<span v-if="data.risk_type == 1">-</span>
						<span v-if="data.risk_type == 2 && data.state == 0" style="color:red">{{data.saas_name}}</span>
						<span v-else>{{data.saas_name}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="账号用户名"
					name="user_name"
					width="80"
				>
					<template #default="{data}">
						<span v-if="data.risk_type == 1">-</span>
						<span v-if="data.risk_type == 2 && data.state == 0" style="color:red">{{data.user_name}}</span>
						<span v-else>{{data.user_name}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="账号姓名"
					name="user_realname"
					width="80"
				>
					<template #default="{data}">
						<span v-if="data.risk_type == 1">-</span>
						<span v-if="data.risk_type == 2">{{data.user_realname}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="登陆客户端"
					width="80"
				>
					<template #default="{data}">
						<span v-if="data.client == 1">移动端</span>
						<span v-else-if="data.client == 0">电脑端</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="风险说明"
					name="risk_remark"
					width="300"
				>
					<template #default="{data}">
						<span v-if="data.risk_remark">{{data.risk_remark}}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="请求参数"
					name="query_param"
					width="200"
				>
					<template #default="{data}">
						<span v-if="data.query_param">{{data.query_param}}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="请求IP"
					name="query_ip"
					width="120"
				>
					<template #default="{data}">
						<span v-if="data.query_ip">{{data.query_ip}}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="风险时间"
					name="create_date"
					width="140"
				>
				</c-table-column>
				
				<c-table-column
					label="自动解除时间"
					name="pre_risk_date"
					width="140"
				>
					<template #default="{data}">
						<span v-if="data.state == 0" style="color:red">{{data.pre_risk_date}}</span>
						<span v-if="data.state == 1" style="color:green">-</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="风险解除时间"
					name="unrisk_date"
					width="140"
				>
					<template #default="{data}">
						<span v-if="data.state == 0">-</span>
						<span v-if="data.state == 1">{{data.pre_risk_date||data.unrisk_date}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="风险解除人"
					name="unrisk_date"
					width="80"
				>
					<template #default="{data}">
						<span v-if="data.state == 0">-</span>
						<span v-if="data.state == 1">{{data.unrisk_user_realname||'自动解除'}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="90"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_risk_removal') && data.state == 0" icon="tf-cancel" @click="removal(data)">解除风险</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		components: {
			
		},
		computed: {
			//...mapState(['saasTypeDic' ])
		},
		props: {
			type: String
		},

		data() {
			return {
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/sys_saas/risklog/list',
					data
				});
			},

			/******解除风险*******/
			removal(data){
				this.$confirm({
					message:'确认解除【'+data.phone+'】的登陆风险吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys_saas/risklog/removal',
							data: {id: data.id},
							loading: true,
							success: result => {
								this.$message({
									message:'风险解除成功，用户可以正常登陆了',  // 提示内容,
									type: 'success'
								});
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			}
		}
	}
</script>